export default __webpack_public_path__ + "static/media/disabled-checkmark.ca1d29c1.svg";